import React from "react";
import metaData from "../../../../data/metaData";
import { Tag } from "antd";

const PaymentLogo = ({ payment }) => {
  let { method, gateway, code } = payment;
  const logos = {
    asiapay: "asiaPayLogo-square.png",
    paypal: "payPalLogo-square.png",
  };

  if (method === "online" && logos[gateway]) {
    return (
      <img
        style={{ width: 50, height: 50, objectFit: "cover" }}
        src={`${metaData.blobPreURL}${logos[gateway]}${metaData.blobPostURL}`}
        alt={`${gateway} logo`}
      />
    );
  } else if (method === "physical") {
    return <Tag style={{ fontSize: "1rem" }}>Paid at Shop</Tag>;
  } else if (method === "estamp") {
    return <Tag style={{ fontSize: "1rem" }}>Coin Redeem</Tag>;
  } else if (method === "promotionCode") {
    return <Tag style={{ fontSize: "1rem" }}>{`Code: ${code}`}</Tag>;
  } else if (method === "welcome") {
    return <Tag style={{ fontSize: "1rem" }}>Welcome</Tag>;
  } else if (method === "referrer") {
    return <Tag style={{ fontSize: "1rem" }}>Referrer</Tag>;
  } else if (method === "referee") {
    return <Tag style={{ fontSize: "1rem" }}>Referee</Tag>;
  }
  return "--";
};

export default PaymentLogo;
